const countries = {
  Brazil: {
    flag: "https://flagcdn.com/w320/br.png",
    name: "Brazil",
    name_ar: "البرازيل"
  },
  Canada: {
    flag: "https://flagcdn.com/w320/ca.png",
    name: "Canada",
    name_ar: "كندا"
  },
  Congo: {
    flag: "https://flagcdn.com/w320/cd.png",
    name: "Congo",
    name_ar: "الكونغو"
  },
  Egypt: {
    flag: "https://flagcdn.com/w320/eg.png",
    name: "Egypt",
    name_ar: "مصر"
  },
  London: {
    flag: "https://flagcdn.com/w320/gb.png",
    name: "London",
    name_ar: "لندن"
  },
  Iran: {
    flag: "https://flagcdn.com/w320/ir.png",
    name: "Iran",
    name_ar: "إيران"
  },
  Spain: {
    flag: "https://flagcdn.com/w320/es.png",
    name: "Spain",
    name_ar: "إسبانيا"
  },
  China: {
    flag: "https://flagcdn.com/w320/cn.png",
    name: "China",
    name_ar: "الصين"
  },

  KSA: {
    flag: "https://flagcdn.com/w320/sa.png",
    name: "Saudi Arabia",
    name_ar: "المملكة العربية السعودية"
  },
  Kuwait: {
    flag: "https://flagcdn.com/w320/kw.png",
    name: "Kuwait",
    name_ar: "الكويت"
  },
  Pakistan: {
    flag: "https://flagcdn.com/w320/pk.png",
    name: "Pakistan",
    name_ar: "باكستان"
  },
  Purchase: {
    flag: "https://cdn-icons-png.flaticon.com/512/545/545705.png",
    name: "Purchase",
    name_ar: "شراء"
  },
  Qatar: {
    flag: "https://flagcdn.com/w320/qa.png",
    name: "Qatar",
    name_ar: "قطر"
  },
  Romania: {
    flag: "https://flagcdn.com/w320/ro.png",
    name: "Romania",
    name_ar: "رومانيا"
  },
  Russia: {
    flag: "https://flagcdn.com/w320/ru.png",
    name: "Russia",
    name_ar: "روسيا"
  },
  Turkey: {
    flag: "https://flagcdn.com/w320/tr.png",
    name: "Turkey",
    name_ar: "تركيا"
  },
  UAE: {
    flag: "https://flagcdn.com/w320/ae.png",
    name: "UAE",
    name_ar: "الإمارات العربية المتحدة"
  },
  UK: {
    flag: "https://flagcdn.com/w320/gb.png",
    name: "UK",
    name_ar: "المملكة المتحدة"
  },
  Mixed: {
    flag: "https://cdn-icons-png.flaticon.com/512/3304/3304508.png",
    name: "Mixed",
    name_ar: "مختلط"
  },
  "NA (احصاء)": {
    flag: "https://cdn-icons-png.flaticon.com/512/1828/1828911.png",
    name: "NA (Statistics)",
    name_ar: "غير متاح (إحصاء)"
  },

  // Custom Organizations or donors — placeholder icons
  "Cooperative Charitable Association in Nabatieh": {
    flag: "https://cdn-icons-png.flaticon.com/512/2206/2206368.png",
  },
  "Cortas ": {
    flag: "https://cdn-icons-png.flaticon.com/512/3159/3159066.png",
    name: "Cortas",
    name_ar: "كورتاس"
  },
  "Doctor Rajeh Zaher Charity": {
    flag: "https://cdn-icons-png.flaticon.com/512/3062/3062634.png",
  },
  "HM GLOBAL DIS TIC.L through Ibrahim Hajj": {
    flag: "https://cdn-icons-png.flaticon.com/512/3145/3145765.png",
  },
  "Lotex International B.V. through the Supreme Islamic Shiite Council": {
    flag: "https://cdn-icons-png.flaticon.com/512/2857/2857530.png",
  },
  "Ministry of Economy": {
    flag: "https://cdn-icons-png.flaticon.com/512/1077/1077114.png",
    name: "Ministry of Economy",
    name_ar: "وزارة الاقتصاد"
  },
  "Namaa Organization": {
    flag: "https://cdn-icons-png.flaticon.com/512/2910/2910795.png",
  },
  TIKA: {
    flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/TIKA_logo.svg/512px-TIKA_logo.svg.png",
    name: "TIKA",
    name_ar: "تيكا"
  },
  Tawfeer: {
    flag: "https://cdn-icons-png.flaticon.com/512/681/681494.png",
    name: "Tawfeer",
    name_ar: "توفير"
  },
  "Tekstil Konfeksyon through the Supreme Islamic Shiite Council": {
    flag: "https://cdn-icons-png.flaticon.com/512/2838/2838772.png",
  },
};

export default countries;
